<template>
    <div class="w3-margin">
        <div v-if="isNotRole" class="w3-text-red w3-large w3-center">
            Nincs jogosultsága a funkció használatáshoz!
        </div>
        <div v-else>
            <h4 class="page-title">Moderálás</h4>  
            <div v-if="commentList" class="w3-clear">
                <div v-for="(item, index) in orderedCommentList" :key="index">
                    <div class="w3-margin-top w3-border">
                        <div class="w3-padding w3-light-grey">
                            {{item.hikeName}} 
                            <span v-on:click="moderalComment(item,2)" class="cursorpointer w3-text-green w3-right" title="Hozzászólás engedélyezése"><font-awesome-icon icon="check" class="w3-text-green"></font-awesome-icon></span> 
                            <span v-on:click="moderalComment(item,3)" class="cursorpointer w3-text-green w3-right" title="Hozzászólás letiltása"><font-awesome-icon icon="times-circle" class="w3-text-red"></font-awesome-icon>&nbsp;</span>                        
                       
                            <span class="w3-right">
                                {{item.userName}}
                                [<i>{{item.creatdate | filterDateTimeFormat}}</i>]&nbsp;
                            </span>
                        </div>
                        <div class="w3-justify w3-padding" v-html="$nl2br(item.comment)"></div>
                    </div>
                </div>
            </div>

        </div>                  
    </div>  
</template>

<script>
const fb = require('../firebase.js');
import {store} from "../store.js";
export default {
    name: 'OwnHikes',
    data() {
        return {
            isNotRole:false,
            commentList:null,
            sortKey: 'name',
            reverse: 'asc',
            filter:{
                "name":"",
                "status":"",
            },                       
        }
    },
    computed: {   
        orderedCommentList: function () {
            var orderedList=_.orderBy(this.commentList, 'creatdate', 'asc');
            var filteredList = orderedList.filter((item) => {                
                const statusFilter = (item.status==1);
                return statusFilter;
            });  
            return filteredList;            
        }
    },
    methods:{
        moderalComment(item,status){
            let self = this;
            var m="engedélyezed";
            if (status==3) m="letíltod";
            self.$dialog.confirm(this.$setDialogMsg("w3-yellow","Törlés","Biztosan " + m + " a hozzászólást?"))
            .then(function(dialog) {
                item.status=status;
                fb.UpdateComment(item).then(res=>{
                    if (status==2) self.$dialog.alert(self.$setDialogMsg('w3-green','Mentés',"A hozzászólás engedélyezése megtörtént.")); 
                    if (status==3) self.$dialog.alert(self.$setDialogMsg('w3-green','Mentés',"A hozzászólás letiltása megtörtént."));  
    
                }).catch(e=>{  
                    console.log(e);      
                    self.$hideSpinner();
                    self.$dialog.alert(self.$setDialogMsg('w3-red','Hibaüzenet',"Hiba történt a művelet során"));                 
                })
            })
        },
    
        getComments(){
                this.$showSpinner();            
                fb.GetCommentsByStatus(1).then(res=>{
                    this.commentList = res;
                    this.$hideSpinner();
                }).catch(e=>{
                    console.log(e);                
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt az adatok betöltése során.'));
                }); 
        },  
    },
    mounted() {
        if (this.$store.getters.userProfile){
            if (fb.IsRouteAdmin(this.$store.getters.userProfile.uid)) {
                if (this.isOnline) {
                    this.getComments();
                }
            } else this.isNotRole=true;
        } else this.isNotRole=true;
    },    
}
</script>

